export { default } from './PlaceZoneBuilder.vue'
